import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-560cc4de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "comment__avatar d-flex justify-content-center"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "submenu d-flex align-items-end"
}
const _hoisted_5 = { class: "d-flex justify-content-between w-100 mb-2" }
const _hoisted_6 = { class: "fs-8 me-3 me-sm-0" }
const _hoisted_7 = { class: "d-flex flex--column" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-start mb-2 me-3"
}

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Avatar from '@/components/avatar'
import Submenu from '@/components/submenu/index.vue'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef, PropType } from 'vue-demi'
import { useStore } from 'vuex'
import { CHAT_STORE, COMMUNITY_STORE, ROOT_STORE } from '@/store/constants'
import relativeTime from 'dayjs/plugin/relativeTime'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import { useRoute } from 'vue-router'
import { ChangeTime } from '@/constants/datepicker.ts'
import TargetTag from '@/components/target-tag/index.vue'
import { ref, onMounted, watch } from 'vue'
import { ChatStateTypes } from '@/store/modules/chat'


export default /*#__PURE__*/_defineComponent({
  props: {
  source: {
    type: Object,
    default: null,
  },
  partner_post: {
    type: Object as PropType<{ partner_avatar_url: string; partner_display_name: string; partner_user_type: 'alumni' | 'employee' | 'admin' | 1 | 2 | 3 }>,
  },
  is_admin: {
    type: Boolean,
    default: false,
  },
  users: {
    type: Object,
    required: false,
  },
  id_comment: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

dayjs.locale('ja')

dayjs.extend(relativeTime)

const store = useStore()
const route = useRoute()
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const talk_room_data = computed<ComputedRef<Pick<ChatStateTypes, 'talk_room'>>>(() => store.getters[CHAT_STORE.GETTERS.TALK_ROOM])

const first_chat = ref<HTMLElement>()
const observer = ref()
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])

const getData = (page: number) => {
  store.dispatch(CHAT_STORE.ACTIONS.GET_TALK_ROOM, { id: route.params?.talkroom_id, params: { ...(page && { page }) } })
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (!talk_room_data.value || page.value >= talk_room_data.value?.talk_room?.total_pages) return
      store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT)
      getData(page.value)
    }
  })
  if (first_chat.value) {
    observer?.value?.observe(first_chat.value)
  }
})
watch(
  () => first_chat.value,
  () => {
    if (first_chat.value) {
      observer?.value?.observe(first_chat.value)
    }
  }
)

const currentLoggedInUser = computed<ComputedRef<number>>(() => {
  if (route.path.includes('admin')) return store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.admin_community_management_id
  return store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.community_management_id
})

const checkChatBelongLoggedInUser = computed(() => {
  if (route.path.includes('admin')) return props.source?.user_type === 'community_admin'
  return currentLoggedInUser.value === props.source?.community_management_id
})

const setCurrentMessage = (): void => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_MESSAGE_ID, props.source.id)
}

const ReplayName = (
  is_deleted_in_30_days: string | number,
  available: boolean,
  family_name: string,
  given_name: string,
  user_type,
  management_no: string,
  display_name: string
) => {
  if (!is_deleted_in_30_days) {
    if (!available) {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[一時停止]' + `（${display_name}）`
      }
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else {
      if ([2, 'alumni'].includes(user_type) && display_name) {
        return management_no + ' ' + family_name + ' ' + given_name + ' ' + `（${display_name}）`
      }
      return management_no + ' ' + family_name + ' ' + given_name
    }
  } else if (is_deleted_in_30_days === 1 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[脱退済み]' + `（${display_name}）`
    }
    return management_no + ' ' + family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    return '脱退済みユーザ'
  } else {
    if ([2, 'alumni'].includes(user_type) && display_name) {
      return management_no + ' ' + family_name + ' ' + given_name + ' ' + `（${display_name}）`
    }
    return management_no + ' ' + family_name + ' ' + given_name
  }
}

const time = ref(ChangeTime(props?.source?.created_at))

const changTimeCurrent = (created_at) => {
  const newTime = dayjs(created_at).format('YYYY/MM/DD HH:mm:ss')
  const date = dayjs(new Date())
  const second = date.diff(dayjs(newTime), 'second')
  if (second < 60) {
    setInterval(function () {
      time.value = ChangeTime(created_at)
    }, 1000)
  } else if (second > 60 && second < 3600) {
    setInterval(function () {
      time.value = ChangeTime(created_at)
    }, 60000)
  } else {
    clearInterval()
  }
  return time.value
}

return (_ctx: any,_cache: any) => {
  return (__props.source?.id === 'first_chat_page')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: (_value, _refs) => {
          _refs['first_chat'] = _value
          first_chat.value = _value
        }
      }, null, 512))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: __props.source?.id,
        class: _normalizeClass(['pb-4 row', _unref(checkChatBelongLoggedInUser) ? 'revert' : ''])
      }, [
        (!_unref(checkChatBelongLoggedInUser))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(Avatar), {
                      userType: __props.source?.user_type,
                      size: 'small',
                      is_deleted_in_30_days: __props.source?.is_deleted_in_30_days,
                      user_image_url: __props.source.user_image_url
                    }, null, 8, ["userType", "is_deleted_in_30_days", "user_image_url"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(Submenu, {
                menu: [null, { title: _unref(translate)('SO65delete') }],
                dataBs: [['modal', '#deleteChat']],
                onClick: setCurrentMessage
              }, null, 8, ["menu"])
            ])),
        _createElementVNode("div", {
          class: _normalizeClass([_unref(checkChatBelongLoggedInUser) ? 'col-9' : 'col-sm-9 col-12'])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (!_unref(checkChatBelongLoggedInUser))
              ? (_openBlock(), _createBlock(UserAliasIcon, {
                  key: 0,
                  title: 
            !__props.is_admin
              ? __props.source?.display_name
              : ReplayName(
                  __props.source?.is_deleted_in_30_days,
                  __props.source?.available,
                  __props.source?.family_name,
                  __props.source?.given_name,
                  __props.source?.user_type,
                  __props.source?.management_no,
                  __props.source?.display_name
                )
          ,
                  userType: __props.source?.user_type
                }, null, 8, ["title", "userType"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(changTimeCurrent(__props.source?.created_at)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!_unref(checkChatBelongLoggedInUser) && _unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_unref(Avatar), {
                    userType: __props.source?.user_type,
                    is_deleted_in_30_days: __props.source?.is_deleted_in_30_days,
                    user_image_url: __props.source.user_image_url,
                    size: 'small'
                  }, null, 8, ["userType", "is_deleted_in_30_days", "user_image_url"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["mx-auto comment__content px-4 py-3 w-100 position-relative text me-3 me-sm-0", { 'message-highlight': __props.source?.id === __props.id_comment }])
            }, [
              _createVNode(TargetTag, {
                data: __props.source?.content,
                users: __props.users
              }, null, 8, ["data", "users"])
            ], 2)
          ])
        ], 2)
      ], 10, _hoisted_1))
}
}

})